export function isRestrictedSegment(
  segment: Readonly<{
    fileId?: string | null;
    ownerId: string | null;
  }>,
  rootOwnerId: string | null | undefined,
  rootOwnerType: 'Group' | 'Service' | null | undefined,
) {
  return Boolean(
    rootOwnerType === 'Group' &&
    segment.fileId &&
    rootOwnerId &&
    segment.ownerId &&
    segment.ownerId !== rootOwnerId,
  );
}
